/** One-shot theme from POST /api/login (avoids an extra GET /api/me/theme). */
let bufferedLoginTheme: unknown | undefined;

export function consumeLoginThemeResponse(theme: unknown | undefined): void {
  bufferedLoginTheme = theme;
}

export function takeLoginThemeIfAny(): unknown | undefined {
  const t = bufferedLoginTheme;
  bufferedLoginTheme = undefined;
  return t;
}
